module.exports = __webpack_public_path__ + "static/media/logo-brand.98d5b0b8.svg";